import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-694bacaa"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "contents" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", { class: "title contents-title" }, "ご連絡先（あなた様）", -1))
const _hoisted_3 = { class: "table" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_FormInput = _resolveComponent("FormInput")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _createElementVNode("div", null, [
      _createElementVNode("table", _hoisted_3, [
        _createElementVNode("tbody", null, [
          _createVNode(_component_FormInput, {
            modelValue: _ctx.state.name,
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.state.name) = $event)),
            name: '氏名',
            required: true,
            id: 'name',
            width: '168px',
            requiredCheck: _ctx.props.requiredCheck
          }, null, 8, ["modelValue", "requiredCheck"]),
          _createVNode(_component_FormInput, {
            modelValue: _ctx.state.mailAddress,
            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.state.mailAddress) = $event)),
            name: 'メールアドレス',
            required: true,
            id: 'mailAddress',
            type: 'email',
            width: '168px',
            requiredCheck: _ctx.props.requiredCheck
          }, null, 8, ["modelValue", "requiredCheck"]),
          _createVNode(_component_FormInput, {
            modelValue: _ctx.state.address,
            "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.state.address) = $event)),
            name: '住所',
            required: false,
            id: 'address',
            textarea: true,
            width: '168px',
            requiredCheck: _ctx.props.requiredCheck
          }, null, 8, ["modelValue", "requiredCheck"]),
          _createVNode(_component_FormInput, {
            modelValue: _ctx.state.phoneNumber,
            "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.state.phoneNumber) = $event)),
            name: '電話番号',
            required: false,
            id: 'phoneNumber',
            width: '168px',
            requiredCheck: _ctx.props.requiredCheck
          }, null, 8, ["modelValue", "requiredCheck"])
        ])
      ])
    ])
  ]))
}